import { createAction } from '@reduxjs/toolkit';
// types
import { QUIZ_PROGRESS } from './types';

export const setQuizProgress = createAction<any>(QUIZ_PROGRESS); // Change Type
